import { render, staticRenderFns } from "./approvalPelunasanfrm.vue?vue&type=template&id=bd5410e0&"
import script from "./approvalPelunasanfrm.vue?vue&type=script&lang=js&"
export * from "./approvalPelunasanfrm.vue?vue&type=script&lang=js&"
import style0 from "./approvalPelunasanfrm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports